import React from 'react';
import { toast } from 'react-toastify';

export const confirmDialog = (message) => {
  return new Promise((resolve) => {
    const toastId = toast.info(
      <div>
        <p style={{ marginBottom: '12px', fontSize: '14px' }}>{message}</p>
        <div style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end' }}>
          <button
            onClick={() => {
              toast.dismiss(toastId);
              resolve(false);
            }}
            style={{
              padding: '8px 16px',
              background: '#6b7280',
              color: 'white',
              border: 'none',
              borderRadius: '6px',
              cursor: 'pointer',
              fontSize: '14px',
              fontWeight: '500'
            }}
          >
            Cancel
          </button>
          <button
            onClick={() => {
              toast.dismiss(toastId);
              resolve(true);
            }}
            style={{
              padding: '8px 16px',
              background: '#dc2626',
              color: 'white',
              border: 'none',
              borderRadius: '6px',
              cursor: 'pointer',
              fontSize: '14px',
              fontWeight: '500'
            }}
          >
            Confirm
          </button>
        </div>
      </div>,
      {
        position: 'top-center',
        autoClose: false,
        closeButton: false,
        draggable: false,
        closeOnClick: false,
        style: { minWidth: '400px' }
      }
    );
  });
};

export const promptDialog = (message) => {
  return new Promise((resolve) => {
    let inputValue = '';
    
    const toastId = toast.info(
      <div style={{width: "100%"}}>
        <p style={{ marginBottom: '12px', fontSize: '14px' }}>{message}</p>
        <input
          type="text"
          onChange={(e) => { inputValue = e.target.value; }}
          placeholder="Enter text..."
          autoFocus
          style={{
            width: '100%',
            padding: '10px',
            marginBottom: '12px',
            border: '1px solid #d1d5db',
            borderRadius: '6px',
            fontSize: '14px',
            outline: 'none',
            boxSizing: 'border-box'
          }}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              toast.dismiss(toastId);
              resolve(inputValue || '');
            } else if (e.key === 'Escape') {
              toast.dismiss(toastId);
              resolve(null);
            }
          }}
        />
        <div style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end' }}>
          <button
            onClick={() => {
              toast.dismiss(toastId);
              resolve(null);
            }}
            style={{
              padding: '8px 16px',
              background: '#6b7280',
              color: 'white',
              border: 'none',
              borderRadius: '6px',
              cursor: 'pointer',
              fontSize: '14px',
              fontWeight: '500'
            }}
          >
            Cancel
          </button>
          <button
            onClick={() => {
              toast.dismiss(toastId);
              resolve(inputValue || '');
            }}
            style={{
              padding: '8px 16px',
              background: '#2563eb',
              color: 'white',
              border: 'none',
              borderRadius: '6px',
              cursor: 'pointer',
              fontSize: '14px',
              fontWeight: '500'
            }}
          >
            Submit
          </button>
        </div>
      </div>,
      {
        position: 'top-center',
        autoClose: false,
        closeButton: false,
        draggable: false,
        closeOnClick: false,
        style: { minWidth: '450px' }
      }
    );
  });
};
